import { constants } from "@newsela/angelou";

const { ui } = constants.colors;

export const bulletPointsCss = {
  li: {
    padding: "4px 0",
  },
};

export const acceptTermCheckCss = {
  root: {
    backgroundColor: ui.neutral[25],
  },
};
